import React from "react";

const historyData = [
  {
    id: 1,
    snippet: "Lorem ipsum dolor sit amet consectetur adipiscing elit",
    user: "Alice",
    comments: 24,
    time: "1 min ago",
  },
  {
    id: 2,
    snippet: "Vestibulum ante ipsum primis in faucibus orci luctus",
    user: "Bob",
    comments: 12,
    time: "5 min ago",
  },
  {
    id: 3,
    snippet: "Pellentesque habitant morbi tristique senectus et netus",
    user: "Charlie",
    comments: 8,
    time: "15 min ago",
  },

  {
    id: 4,
    snippet: "Lorem ipsum dolor sit amet consectetur adipiscing elit",
    user: "Alice",
    comments: 24,
    time: "1 min ago",
  },
  {
    id: 5,
    snippet: "Vestibulum ante ipsum primis in faucibus orci luctus",
    user: "Bob",
    comments: 12,
    time: "5 min ago",
  },
  // {
  //   id: 6,
  //   snippet: "Pellentesque habitant morbi tristique senectus et netus",
  //   user: "Charlie",
  //   comments: 8,
  //   time: "15 min ago",
  // },


  // {
  //   id: 7,
  //   snippet: "Lorem ipsum dolor sit amet consectetur adipiscing elit",
  //   user: "Alice",
  //   comments: 24,
  //   time: "1 min ago",
  // },
  // {
  //   id: 8,
  //   snippet: "Vestibulum ante ipsum primis in faucibus orci luctus",
  //   user: "Bob",
  //   comments: 12,
  //   time: "5 min ago",
  // },
  // {
  //   id: 9,
  //   snippet: "Pellentesque habitant morbi tristique senectus et netus",
  //   user: "Charlie",
  //   comments: 8,
  //   time: "15 min ago",
  // },



  // {
  //   id: 10,
  //   snippet: "Lorem ipsum dolor sit amet consectetur adipiscing elit",
  //   user: "Alice",
  //   comments: 24,
  //   time: "1 min ago",
  // },
  // {
  //   id: 12,
  //   snippet: "Vestibulum ante ipsum primis in faucibus orci luctus",
  //   user: "Bob",
  //   comments: 12,
  //   time: "5 min ago",
  // },
  // {
  //   id: 13,
  //   snippet: "Pellentesque habitant morbi tristique senectus et netus",
  //   user: "Charlie",
  //   comments: 8,
  //   time: "15 min ago",
  // },


  // {
  //   id: 14,
  //   snippet: "Lorem ipsum dolor sit amet consectetur adipiscing elit",
  //   user: "Alice",
  //   comments: 24,
  //   time: "1 min ago",
  // },
  // {
  //   id: 15,
  //   snippet: "Vestibulum ante ipsum primis in faucibus orci luctus",
  //   user: "Bob",
  //   comments: 12,
  //   time: "5 min ago",
  // },
  // {
  //   id: 16,
  //   snippet: "Pellentesque habitant morbi tristique senectus et netus",
  //   user: "Charlie",
  //   comments: 8,
  //   time: "15 min ago",
  // },
];

const ChatHistory = () => {
  return (
    <div>
      {/* Toolbar */}
      <div className="d-flex justify-content-between align-items-center border-bottom p-3">
        <div className="d-flex align-items-center">
          <i className="bi bi-chat-left-text-fill text-dark me-2"></i>
          <span className="fw-bold text-dark">Chat (56)</span>
        </div>
        <div className="d-flex gap-3">
          <div className="dropdown">
            <button
              className="btn btn-outline-dark dropdown-toggle d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
            >
              <i className="bi bi-hdd-network me-2"></i>
               Model
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <button className="dropdown-item">Model A</button>
              </li>
              <li>
                <button className="dropdown-item">Model B</button>
              </li>
              <li>
                <button className="dropdown-item">Model C</button>
              </li>
            </ul>
          </div>
          <div className="dropdown">
            <button
              className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
              type="button"
              data-bs-toggle="dropdown"
            >
              <i className="bi bi-sort-down me-2"></i>
              Sort by
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <button className="dropdown-item">Newest</button>
              </li>
              <li>
                <button className="dropdown-item">Oldest</button>
              </li>
              <li>
                <button className="dropdown-item">Most Popular</button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Chat History */}
      <div className="list-group list-group-flush">
        {historyData.map((item) => (
          <div
            key={item.id}
            className="list-group-item my-1 py-2 rounded-3 border d-flex justify-content-between align-items-center"
          >
            <div className="flex-grow-1 pe-3">{item.snippet}</div>
            <div className="d-flex align-items-center gap-4">
              <span className="fw-medium">{item.user}</span>
              <div className="d-flex align-items-center text-muted">
                <i className="bi bi-chat-dots-fill me-1"></i>
                <small>{item.comments}</small>
              </div>
              <div className="d-flex align-items-center text-muted">
                <i className="bi bi-clock-fill me-1"></i>
                <small>{item.time}</small>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-light"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <i className="bi bi-three-dots-vertical"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button className="dropdown-item">
                      <i className="bi bi-share me-2"></i> Share
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item">
                      <i className="bi bi-pencil-square me-2"></i> Rename
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item">
                      <i className="bi bi-archive me-2"></i> Archive
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item text-danger">
                      <i className="bi bi-trash me-2"></i> Delete
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatHistory;
